import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined';
import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { TicketState } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { Ticket } from '~hooks/useTickets/models';

interface NumberColumnProps {
  number: number;
  sx?: SxProps<Theme>;
  ticket?: Ticket;
}

export default function NumberColumn({ number, sx, ticket }: NumberColumnProps) {
  const isApproved = ticket?.state === TicketState.APPROVED;

  return (
    <Box sx={sx}>
      <Box
        sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', gap: 0.5 }}
      >
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {number}
        </Typography>

        {isApproved && (
          <Tooltip title={t('loads.ticket_approved')}>
            <CheckCircleOutlineOutlined
              sx={(theme) => ({
                color: theme.brandV2.colors.treadGreen,
                height: '16px',
                width: '16px',
              })}
            />
          </Tooltip>
        )}
      </Box>
    </Box>
  );
}
